export default __webpack_public_path__ + "static/media/frame-board.5374cbf6.png";